import { HomeExamPaperProprietary } from './HomeExamPaperProprietary';
export default HomeExamPaperProprietary;